import React from "react";
import "./Cards.css";
const Cards = () => {
  return (
    <>
      <div className="Cards">Card Card Card</div>
    </>
  );
};
export default Cards;
